
export const DATE_VALIDATION = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
export const RAW_PHONE = /[^0-9\\.]+/g;
export const ANY_PHONE = /^(?:\([2-9]\d{2}\)\ ?|[2-9]\d{2}(?:\-?|\ ?))[2-9]\d{2}[- ]?\d{4}$/;// eslint-disable-line no-useless-escape
export const NEVER_EXPIRES = 'Never Expires';
export const NO_ASSIGNMENTS = 'No Assignments';
export const NEWLINE = '\n';
export const CRLF = '\r\n';
export const EMPTY_OPTION = {id: -1, name: ''};
export const XLSX_FILE_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const CSV_FILE_TYPE = 'text/csv';
export const PDF_FILE_TYPE = 'application/pdf';
export const PNG_FILE_TYPE = 'image/png';
export const GIF_FILE_TYPE = 'image/gif';
export const JPG_FILE_TYPE = 'image/jpg';
export const JPEG_FILE_TYPE = 'image/jpeg';
export const HEIC_EXTENSION = 'heic';
export const YYYYMMDD = 'YYYY-MM-DD';
export const MMDDYYYY = 'MM/DD/YYYY';